import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-77bf9fde"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  style: {
    "height": "calc(100% - 20px)"
  }
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cc"
}, [/*#__PURE__*/_createTextVNode(" Copyright © 2023   "), /*#__PURE__*/_createElementVNode("a", {
  href: "https://github.com/TeamPGM/PagerMaid-Pyro",
  target: "_blank",
  class: "link-secondary"
}, " PagerMaid-Pyro "), /*#__PURE__*/_createTextVNode("   X   "), /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  href: "https://github.com/AmiyaBot/Amiya-Bot-console2",
  class: "link-secondary",
  rel: "noopener"
}, " Amiya-Bot-console2 ")], -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_view = _resolveComponent("router-view");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_router_view)]), _hoisted_2], 64);
}